import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% korting op geselecteerde items',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% korting op totale orderwaarde',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis item bij een item',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis item bij een orderwaarde',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Koop één, krijg één voor halve prijs',
  [OFFER_KIND.BOGO]: 'Koop één, krijg één gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} korting op geselecteerde items',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} korting bij een orderwaarde',
};
